module.exports = __webpack_public_path__ + "static/media/5.76a08561.png";